import { render, staticRenderFns } from "./inner-forward-delivery-list.vue?vue&type=template&id=5a2780cd&scoped=true"
import script from "./inner-forward-delivery-list.vue?vue&type=script&lang=js"
export * from "./inner-forward-delivery-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2780cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a2780cd')) {
      api.createRecord('5a2780cd', component.options)
    } else {
      api.reload('5a2780cd', component.options)
    }
    module.hot.accept("./inner-forward-delivery-list.vue?vue&type=template&id=5a2780cd&scoped=true", function () {
      api.rerender('5a2780cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/inner-management/inner-forward-delivery-list/inner-forward-delivery-list.vue"
export default component.exports